import classnames from 'classnames'
import React, { FC } from 'react'

import productHelper from '@src/quince-site-common/src/helpers/productHelper'
import { PRODUCT_TAGS_IMAGE_LIMIT, TAG_POSITION } from '@src/quince-site-common/src/utils/constants'

import styles from './product-tags.module.scss'
import { ReadyToShip } from './ReadyToShip'

export const ProductTags: FC<{
  applicableTags?: any[]
  spid?: number
  position?: TAG_POSITION
}> = ({ applicableTags = [], spid, position = TAG_POSITION.BOTTOM }) => {
  const renderedTags = () =>
    applicableTags.slice(0, PRODUCT_TAGS_IMAGE_LIMIT).map(tag => {
      return (
        <li className={classnames(styles.tag, tag.tagType && styles[`tag__${tag.tagType}`])} key={tag.value}>
          {productHelper.getTagValueWithFirstLetterUpperCase(tag.value)}
        </li>
      )
    })

  return (
    <ul className={classnames(styles.tagList, styles[`tagList__${position}`])}>
      {renderedTags()}
      <ReadyToShip spid={spid} />
    </ul>
  )
}
